export const MAX_MOBILE_ADDRESS_LENGTH = 28;
